import script from "./WalletPage.vue?vue&type=script&setup=true&lang=js"
export * from "./WalletPage.vue?vue&type=script&setup=true&lang=js"

import "./WalletPage.vue?vue&type=style&index=0&id=f758e626&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f758e626"]])

export default __exports__